(function () {
  var KEY = 'fiorenci_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function saveWishlist(ids) {
    localStorage.setItem(KEY, JSON.stringify(ids));
  }
  function isWishlisted(id) {
    return getWishlist().indexOf(String(id)) > -1;
  }
  function toggle(id) {
    var ids = getWishlist();
    var idx = ids.indexOf(String(id));
    if (idx > -1) { ids.splice(idx, 1); } else { ids.push(String(id)); }
    saveWishlist(ids);
    return idx === -1; // true if now wishlisted
  }

  function paintButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      btn.classList.toggle('is-active', isWishlisted(id));
    });
  }

  function applyWishlistPageFilter() {
    var ids = getWishlist();
    document.querySelectorAll('[data-wishlist-list]').forEach(function (list) {
      var visibleCount = 0;
      list.querySelectorAll('[data-wishlist-item]').forEach(function (card) {
        var id = card.getAttribute('data-wishlist-item');
        var show = ids.indexOf(String(id)) > -1;
        card.style.display = show ? '' : 'none';
        if (show) visibleCount++;
      });
      var empty = list.querySelector('[data-wishlist-empty]');
      if (empty) empty.style.display = visibleCount === 0 ? '' : 'none';
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    var id = btn.getAttribute('data-product-id');
    var nowActive = toggle(id);
    btn.classList.toggle('is-active', nowActive);
    applyWishlistPageFilter();
  });

  // Cards added after page load (the product page's "Recently viewed" row) need their hearts painted too.
  document.addEventListener('fiorenci:cards-added', paintButtons);

  document.addEventListener('DOMContentLoaded', function () {
    paintButtons();
    applyWishlistPageFilter();
  });
})();
